import React from 'react';
import PropTypes from 'prop-types';

// Constellation Components
import { Spacer } from '@zillow/constellation';
import { Link } from '@zillow/zrs-comet';

// Styled Components
import { StyledTourCardSelectableControls } from './StyledComponents';

const propTypes = {
    isSelected: PropTypes.bool.isRequired,
    onView: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};

const TourCardSelectableControls = ({
    isSelected,
    onView,
    onSelect,
}) => (
    <StyledTourCardSelectableControls>
        <Spacer marginRight="sm">
            <Link onClick={onView}>
            View
            </Link>
        </Spacer>
        <Spacer marginRight="sm">
            <Link onClick={onSelect}>
                {isSelected ? 'Deselect' : 'Select'}
            </Link>
        </Spacer>
    </StyledTourCardSelectableControls>
);

TourCardSelectableControls.propTypes = propTypes;

export default TourCardSelectableControls;
